<script setup>
</script>

<template>
    <main class="auth">

        <img class="logo" src="/public/internal/images/logo-vertical.png" srcset="/public/internal/images/logo-vertical@2x.png 2x" alt="">

        <div class="auth-form">
            <p>Check your inbox — we've sent your new password to your email address.</p>
        </div>
        <router-link class="link-forgot" to="/auth/login">Back to login</router-link>
    </main>
</template>
